import { render } from "./TranslateLanguageSelect.vue?vue&type=template&id=6210f2a6&scoped=true"
import script from "./TranslateLanguageSelect.vue?vue&type=script&lang=js"
export * from "./TranslateLanguageSelect.vue?vue&type=script&lang=js"

import "./TranslateLanguageSelect.vue?vue&type=style&index=0&id=6210f2a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6210f2a6"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QAvatar,QTooltip,QMenu,QList,QItemLabel,QItem,QItemSection});qInstall(script, 'directives', {ClosePopup});
